import React from 'react'
import './landing.css'
import { IoCopyOutline } from 'react-icons/io5'
import imgTokenomicsFrog from '../../assets/landing/tokenomics-frog.svg'
import imgSun from '../../assets/landing/tokenomics-sun.svg'
import cloudOne from '../../assets/landing/tokenomics-cloud-1.svg'
import cloudTwo from '../../assets/landing/tokenomics-cloud-2.svg'
import cloudThree from '../../assets/landing/tokenomics-cloud-3.svg'
import stoneBg from '../../assets/landing/shape_stone_1.svg'

const Tokenomics = () => {
  return (
    <div
      className="tokenomics-bg bg-no-repeat bg-cover pt-28 pb-[50px] relative"
      id="tokenomics"
    >
      <img
        src={stoneBg}
        alt=""
        className="absolute bottom-[-20px] md:bottom-[-60px] w-full z-50"
      />
      <div className="relative">
        <h2 className="font-sourGummy text-[44px] md:text-[99px] font-extrabold text-black py-4 md:py-10 text-center z-30">
          Our Tokenomics
        </h2>

        <img
          src={cloudOne}
          alt=""
          className="absolute top-[-50px] md:top-[20px] right-[30px] md:right-[100px] w-[150px] md:w-[220px]"
        />
      </div>
      <div className="max-w-[1100px] w-full mx-auto flex flex-col md:flex-row items-center justify-around gap-6 text-[17px] md:text-[27px] font-sourGummy px-3 relative z-[50]">
        <img
          src={cloudThree}
          alt=""
          className="absolute top-[100px] left-[-50px] md:left-[-130px] w-[120px] md:w-[220px] z-0"
        />
        <img
          src={cloudTwo}
          alt=""
          className="absolute top-[-40px] md:top-[10px] right-[0px] w-[80px] md:w-[220px] z-0"
        />
        <div className="flex items-center justify-between md:w-full gap-3">
          <div className="border md:w-full border-black shadow-lg py-2 shadow-black text-black bg-white rounded-lg px-8">
            Name: Little Pepe
          </div>
          <div className="border md:w-full border-black shadow-lg py-2 shadow-black text-black bg-white rounded-lg px-8 z-50">
            Symbol: LilPepe
          </div>
        </div>
        <div className="border border-black shadow-lg shadow-black text-black bg-white rounded-lg px-8 flex items-center justify-between gap-3 w-full md:w-[791px] py-2 z-[50]">
          <span className="w-full">Contract Address: 0xDD...0315</span>
          <button onClick={() => { navigator.clipboard.writeText("0xDD..0315") }}>
            <IoCopyOutline />
          </button>
        </div>
      </div>
      <div className="w-full flex items-center justify-center pb-[150px] md:pb-[200px] pt-[150px] md:pt-[20px] relative">
        <img
          src={imgTokenomicsFrog}
          alt=""
          className="w-[242px] h-[250px] md:w-auto md:h-auto"
        />

        <img
          src={imgSun}
          alt=""
          className="absolute top-[-280px] md:top-[-320px] left-[30px] md:left-[100px] w-[100px] md:w-[220px]"
        />

        <div className="absolute top-[150px] left-[20px] md:left-[40px] tokenomics-round-bg font-sourGummy flex flex-col items-center justify-center max-w-[119px] h-[53px] md:max-w-[342px] md:h-[152px] w-full bg-cover">
          <p className="uppercase text-black text-[12px] md:text-[30px] font-bold">
            Presale:
          </p>
          <p className="text-[#508FF9] text-[14px] md:text-[40px] font-extrabold">
            26.5%
          </p>
        </div>
        <div className="absolute top-[150px] right-[20px] md:right-[40px] tokenomics-round-bg font-sourGummy flex flex-col items-center justify-center max-w-[123px] md:max-w-[342px] h-[55px] md:h-[152px] w-full bg-cover">
          <p className="uppercase text-black text-[12px] md:text-[30px] font-bold">
            Total tokens:
          </p>
          <p className="text-[#508FF9] text-[14px] md:text-[40px] font-extrabold">
            100,000,000,000
          </p>
        </div>

        <div className="absolute  md:top-[360px] left-[20px] md:left-[40px] tokenomics-round-bg font-sourGummy flex flex-col items-center justify-center max-w-[119px] md:max-w-[334px] h-[53px] md:h-[149px] w-full bg-cover">
          <p className="uppercase text-black text-[12px] md:text-[30px] font-bold">
            Staking & rewards:
          </p>
          <p className="text-[#508FF9] text-[14px] md:text-[40px] font-extrabold mt-0">
            13.50%
          </p>
        </div>

        <div className="absolute top-[330px] md:top-[360px] right-[20px] md:right-[40px] tokenomics-round-bg font-sourGummy flex flex-col items-center justify-center max-w-[118px] md:max-w-[334px] h-[54px] md:h-[149px] w-full bg-cover">
          <p className="uppercase text-black text-[12px] md:text-[30px] font-bold">
            Liquidity:
          </p>
          <p className="text-[#508FF9] text-[14px] md:text-[40px] font-extrabold mt-0">
            10%
          </p>
        </div>

        <div className="absolute bottom-[160px] md:bottom-[160px] left-[20px] md:left-[40px] tokenomics-round-bg font-sourGummy flex flex-col items-center justify-center max-w-[118px] md:max-w-[338px] h-[54px] md:h-[151px] w-full bg-cover">
          <p className="uppercase text-black text-[12px] md:text-[30px] font-bold">
            cex reserves:
          </p>
          <p className="text-[#508FF9] text-[14px] md:text-[40px] font-extrabold mt-0">
            10%
          </p>
        </div>

        <div className="absolute bottom-[250px] md:bottom-[160px] right-[20px] md:right-[40px] tokenomics-round-bg font-sourGummy flex flex-col items-center justify-center max-w-[118px] md:max-w-[338px]  h-[54px] md:h-[151px] w-full bg-cover">
          <p className="uppercase text-black text-[12px] md:text-[30px] font-bold">
            chain reserves:
          </p>
          <p className="text-[#508FF9] text-[14px] md:text-[40px] font-extrabold mt-0">
            30%
          </p>
        </div>

        <div className="absolute bottom-[80px] md:bottom-[40px] left-[50%] translate-x-[-50%] tokenomics-round-bg font-sourGummy flex flex-col items-center justify-center max-w-[118px] md:max-w-[338px]  h-[54px] md:h-[151px] w-full bg-cover">
          <p className="uppercase text-black text-[12px] md:text-[30px] font-bold">
            marketing:
          </p>
          <p className="text-[#508FF9] text-[14px] md:text-[40px] font-extrabold mt-0">
            10%
          </p>
        </div>
      </div>
    </div>
  )
}

export default Tokenomics
